import { TMutation, TQuery } from 'app/Requests/types';
import httpDriver from 'app/utils/httpDriver';
import { apiRoutes } from 'topics/utils/apiRoutes';
export const topicRegrabb = async (): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().regrabb, {});
  return data;
};

export const deleteTopics = async ({
  id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.delete(apiRoutes().deleteTopic, {
    data: { ids: [id] },
  });
  return { ...data, successMessage };
};

export const fetchTopCountries = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().trendingRank, {
    topic_id: queryKey[1],
  });
  return data?.payload?.records;
};

export const getTweetsRelatedItemsForTopic = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes().tweetsRelatedItems,
    queryKey[1]
  );
  return data?.payload?.records;
};

export const getPostsRelatedItemsForTopic = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes().postsRelatedItems,
    queryKey[1]
  );
  return data?.payload?.records;
};

export const getVideosRelatedItemsForTopic = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes().videosRelatedItems,
    queryKey[1]
  );
  return data?.payload?.records;
};

export const getNewsRelatedItemsForTopic = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes().newsRelatedItems,
    queryKey[1]
  );
  return data?.payload?.records;
};

export const restoreTopics = async ({
  id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().restoreTopic, {
    ids: [id],
  });
  return { ...data, successMessage };
};

export const trashTopic = async ({
  id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().trashTopic, { ids: [id] });
  return { ...data, successMessage };
};

export const unnecessaryTopics = async ({
  id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().unnecessaryTopic, {
    ids: [id],
  });
  return { ...data, successMessage };
};

export const deleteCategory = async ({
  id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.delete(apiRoutes().deleteCategory, {
    data: { ids: [id] },
  });
  return { ...data, successMessage };
};

export const restoreCategory = async ({
  id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().restoreCategory, {
    ids: [id],
  });
  return { ...data, successMessage };
};

export const trashCategory = async ({
  id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().trashCategory, {
    ids: [id],
  });
  return { ...data, successMessage };
};

export const compareTopics = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes().compareTopics,
    queryKey[1]
  );
  return data;
};

export const compareTopic = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().compareTopic, queryKey[1]);
  return data;
};

export const addNewTopic = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().storeTopic, body);
  return data;
};

export const editTopic = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.put(apiRoutes().updateTopic, body);
  return data;
};

export const getTopicDetails = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().getTopic, {
    topic_id: queryKey[1],
  });
  return data?.payload.records;
};

export const getGrabbingStatus = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().getGrabbingStatus, {
    topic_id: queryKey[1],
  });
  return data?.payload.records;
};
export const getMentionsCount = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().mentionsCard, queryKey[1]);
  return data?.payload?.records?.count;
};

export const getRelatedItems = async ({
  url,
  body,
}: TMutation<any>): Promise<any> => {
  const { data } = await httpDriver.post(url, body);
  return data;
};

export const topicResync = async ({ id }: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().resync, {
    topic_id: id,
  });
  return data;
};

export const getTopicsDetailsTableData = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    `${apiRoutes().basic}/${queryKey[1].slug}`,
    queryKey[1].body
  );
  return data;
};

export const getParentCategories = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(queryKey[1], { limit: 500 });
  return data?.payload?.records.map((cat: any) => ({
    label: cat.name,
    value: cat.id,
  }));
};

export const topicsHideActionAllTab = async ({
  id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().hideActionAllTab, {
    ids: [id],
  });
  return { ...data, successMessage };
};
export const getLastGrabbedOn = async (): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes().topicsLastGrabbedOn);
  return data?.payload;
};
